
import React from 'react';
import TeamCard from './TeamCard';
import { useTranslation } from 'react-i18next';

const TeamSecThree = ({ className }) => {
    const { t } = useTranslation();

  return (
    <section className={className} id="team-sec">
        <div
            className="shape-mockup bg-gradient-shape1 team-bg-gradient1"
            data-top="-5%"
            data-left={0}
        />
        <div
            className="shape-mockup bg-gradient-shape1 team-bg-gradient2"
            data-top="20%"
            data-right="-3%"
            data-left="auto"
        />
        <div className="container">
            <div className="row gy-30" data-cues="slideInUp" data-group="team-card">
                <TeamCard className="col-xl-3 col-lg-4 col-md-6" limit={8} />
            </div>
        </div>
    </section>


  );
};

export default TeamSecThree;